import { createSlice } from '@reduxjs/toolkit';

export const economicActivitySlice = createSlice({
  name: 'economicactivity',
  initialState: {
    economic_activity_list: [],
    economic_activity_list_select: [],
  },
  reducers: {
    setEconomicActivityRedux: (state, { payload }) => {
      state.economic_activity_list = payload;
    },
    setActividadEconomicaSelectRedux: (state, { payload }) => {
      state.economic_activity_list_select = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setEconomicActivityRedux, setActividadEconomicaSelectRedux } =
  economicActivitySlice.actions;
